export const getLightColor = (pattern = 'ABCDEF') => {
    const generateRandomHex = (math, string, count) => {
        return string[math.floor(math.random() * string.length)] + (count && generateRandomHex(math, string, count - 1));
    };

    return `#${generateRandomHex(Math, pattern, 4)}`;
};
